import "../styles/Home.scss";
import { useState, useEffect, useRef } from "react";
import featureCardImage from "../assets/debug.jpg?w=450&h=400&format=webp";

import createPreviewImage from "../assets/landing/create_preview.png?w=450&h=400&format=webp";

// import { InfiniteMovingCards } from "../components/ui/MovingCards.tsx"
import CLink from "../components/CLink";
import HorizontalScroll from "../components/HorizontalScroll";
import Footer from "../components/Footer";
import FeatureCard from "../components/FeatureCard";

export default function Home() {

    const [c0difyTitle, setC0difyTitle] = useState("c0dify.");
    const [blobFreezed, setBlobFreezed] = useState(false);

    const languages = [
        "#javascript",
        "#python",
        "#java",
        "#typescript",
        "#rust",
        "#cpp",
        "#ruby"
    ]


    const technologies = [
        "#reactjs",
        "#laravel",
        "#angularjs",
        "#spring",
        "#docker",
        "#nextjs",
        "#graphql"
    ]

    const concepts = [
        "#data_structures",
        "#algorithms",
        "#competetive",
        "#array",
        "#two_pointer",
        "#sliding_window",
        "#greedy",
    ]

    const blobRef = useRef();

    useEffect(() => {


    }, []);

    const handleMouseMove = (e) => {
        if (!blobFreezed) {
            blobRef.current.style.top = `${e.clientY - 40}px`
            blobRef.current.style.left = `${e.clientX - 40}px`
            blobRef.current.style.filter = `blur(50px) hue-rotate( ${ parseInt((e.clientX / window.innerWidth)*100) }deg )`
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "f") {
            freezeOrUnfreezeBubble();
        }
    }

    const freezeOrUnfreezeBubble = () => {
        console.log( blobFreezed ? "Unfreezing" : "Freezing" )
        setBlobFreezed( blobFreezed => !blobFreezed );
        blobRef.current.style.opacity = "0"
        setTimeout(() => {
            blobRef.current.style.opacity = "1"
        }, 1000);
    }


    return (
        <div className="Home">

            <section className="topText">
                <div className="topContainer" tabIndex={"0"} onMouseMove={handleMouseMove} onDoubleClick={freezeOrUnfreezeBubble}  onKeyDown={handleKeyDown} >
                    <div className="blob" ref={blobRef}></div>
                    <div className="topWrapper">
                        <div className="c0difyText">
                            {c0difyTitle}
                        </div>
                        <div className="c0difyAbout">
                            {"Transform code into competition: Join or create coding contests now!"}
                        </div>
                        <div className="ctaContainer">
                            <CLink className="ctaButton join" to={"/contests"} >Join a contest</CLink>
                            <CLink className="ctaButton create"  to={"/contests/create"} >Create a contest</CLink>
                        </div>
                    </div>
                </div>
            </section>


            <section className="hero">

                <div className="splitInfo">

                    <div className="joinCreateContainer">
                        <div className="join">
                        <div className="title">Join</div>
                        <div className="info">
                            Join and solve challenges in your favourite languages and earn badges!
                            Show off your skills by scoring points and earning badges.
                        </div>
                    </div>

                    <div className="splitter"></div>

                    <div className="create">
                        <div className="title">Create</div>
                        <div className="info">
                            Create and manage your own contests with your own questions and controls.
                            With proctored mode and real-time leaderboards!
                        </div>
                    </div>
                    </div>
                    
                </div>

                <div className="movingTags">
                    <HorizontalScroll texts={languages} speed={5000} />
                    <HorizontalScroll texts={technologies} speed={5000} direction="left" />
                    <HorizontalScroll texts={concepts} speed={5000} />
                </div>

                <div className="featureGrid">
                    <FeatureCard
                        title="Learn What you Like"
                        image={featureCardImage}
                        description="Focus on what you like, focus on what matters. No distractions, just code. Or use our curated problems to learn new concepts."
                    />
                    <FeatureCard
                        title="Create With Ease"
                        image={featureCardImage}
                        description="Create and manage your own contests with your own questions and controls, for free. No fees, no hidden costs, no barriers."
                    />
                    <FeatureCard
                        title="Showcase Your Skills"
                        image={featureCardImage}
                        description="Track your growth and showcase your skills to the world. Every contest you participate in, every skill you master, adds to your profile, literally."
                    />
                    <FeatureCard
                        title="Precise Controls"
                        image={featureCardImage}
                        description="c0dify offers proctored mode to prevent malpractice and real-time leaderboards to grade programmers with precision."
                    />
                    {/* <FeatureCard
                        title="Feature 1"
                        image={featureCardImage}
                        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    /> */}
                </div>

                {/* <div className="features">

                    <div className="plainFeatureCard learnWhatYouLove">
                        <div className="content">
                            <div className="smallTitle forDevelopers">for developers.</div>
                            <div className="title">Learn what you love</div>
                            <div className="text">
                                Learn what drives you and <span className="colorPink">master what matters.</span>
                                <br />
                                <br />
                                <div>
                                    c0dify is a platform focused on Data Structures and Algorithms - covering patterns, problem-solving, and interview prep. Create your own problems, host contests, and benchmark your growth. No distractions - just code, compete, and improve.
                                </div>
                                <CLink to="/code/SAMPLPRBLM">{"Solve a sample problem >"}</CLink>
                            </div>
                        </div>
                        <div className="picture">
                            <img src={featureCardImage} alt="" />
                        </div>
                    </div>

                    <div className="plainFeatureCard createWithEase">
                        <div className="content">
                            <div className="smallTitle forCreators">for creators.</div>
                            <div className="title">Create with ease</div>
                            <div className="text">
                                Create and manage <span className="colorPink">your own coding contests</span> with full control - <span className="colorGreen">no fees, no hidden costs, no barriers.</span>
                                <br />
                                <br />
                                Whether you're organizing for a class, a club, or a public challenge, C0dify provides the tools to set problems, define constraints, monitor submissions, and rank participants in real time. Empower participants, track progress, and build a strong coding culture.
                            </div>
                        </div>
                        <div className="picture">
                            <img src={createPreviewImage} alt="" />
                        </div>
                    </div>

                    <div className="plainFeatureCard earnBadges">
                        <div className="content">
                            <div className="smallTitle forDevelopers">for developers.</div>
                            <div className="title">Earn badges</div>
                            <div className="text">
                                Complete featured problems to unlock badges, accumulate points, and <span className="colorGreen">track your growth.</span>
                                <br />
                                <br />
                                Tackle a curated set of featured challenges built to stretch your thinking and refine your approach. As you progress, earn badges that mark your milestones and score points that reflect your consistency and growth. Build a strong, visible profile that showcases your strengths across core topics. 
                            </div>
                        </div>
                        <div className="picture">
                            <img src={featureCardImage} alt="" />
                        </div>
                    </div>

                    <div className="plainFeatureCard realtimeLeaderboard">
                        <div className="content">
                            <div className="smallTitle forCreators">for creators.</div>
                            <div className="title">Precise controls</div>
                            <div className="text">
                                With <span className="colorGreen">proctored mode</span> to prevent malpractice and  <span className="colorPink">real-time leaderboards</span>, c0dify makes it very easy to grade the programmers.
                                <br />
                                <br />
                                c0dify offers automated scoring to eliminate manual errors and deliver instant results. Detailed analytics track individual and group performance, highlighting strengths and areas for improvement. 
                            </div>
                        </div>
                        <div className="picture">
                            <img src={featureCardImage} alt="" />
                        </div>
                    </div>

                </div> */}


                <div className="comingSoon">
                    <span>
                        COMING SOON.
                    </span>
                </div>

            </section>

            <Footer />

        </div>
    )
} 